import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "message"]
  // A block can set its own thank-you text; without one the server's message
  // is shown.
  static values = { successMessage: String }

  async submit(event) {
    event.preventDefault()
    this.submitTarget.disabled = true

    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(this.element)
      })
      const result = await response.json()

      if (response.ok && result.status === "success") {
        if (result.redirect_url) {
          window.location = result.redirect_url
          return
        }
        this.showMessage(this.successMessageValue || result.message, false)
        this.element.reset()
      } else {
        this.showMessage(result.message, true)
      }
    } catch {
      this.showMessage(null, true)
    }

    this.submitTarget.disabled = false
  }

  showMessage(text, isError) {
    if (!this.hasMessageTarget) return

    this.messageTarget.textContent = text || "Something went wrong. Please try again."
    this.messageTarget.classList.toggle("text-red-600", isError)
    this.messageTarget.classList.toggle("text-green-600", !isError)
    this.messageTarget.hidden = false
  }
}
